import { footerStyles } from "@insite/content-library/Pages/Footer";
import { css } from "styled-components";

footerStyles.page = {
    css: css`
        max-width: 100% !important;
        background-color: black;
    `,
};
